import React from 'react';
import PropTypes from 'prop-types';
import { DEVICE } from '@/constants';
import './style.less';

const Trail = ({ os }) => (
  <React.Fragment>
    { os === DEVICE.MOBILE
      && (
        <React.Fragment>
          <div className="light1" />
          <div className="light2" />
        </React.Fragment>
      )
    }
    <div className="dolphin" />
    <div className="umbrella" />
    <div className="watermelon" />
    <div className="icecream" />
    <div className="sandal" />
    <div className="buoy" />
    <div className="beach" />
  </React.Fragment>
);

Trail.propTypes = {
  os: PropTypes.string,
};
export default Trail;
